import React from 'react';
import '../../static/Heading.css';

const Heading = props => (
	<div className='heading-container pilotly-gradient'>
		<h2 className='heading-title'>{props.title}</h2>
	</div>
);

export default Heading;



// WEBPACK FOOTER //
// ./src/components/global/Heading.js